import { render, staticRenderFns } from "./bianzheng.vue?vue&type=template&id=475ddecb&"
import script from "./bianzheng.vue?vue&type=script&lang=ts&"
export * from "./bianzheng.vue?vue&type=script&lang=ts&"
import style0 from "./bianzheng.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports